/**
 * Import Dependency
 */

/**
 * Import API
 */

/**
 * Declare Variable
 */
const state = {
  active: null,

  events: {
    '2016-04-1': {
      label: 'Introductie'
    }
  },
  timeline: {
    start: '2016-03-1',
    end: '2016-05-1',
    order: ['2016-04-1']
  }
}

const getters = {
  getActivePage: state => {
    return state.active;
  },
  getActiveEventDates: (state) => {
    return state.timeline.order;
  },
  getEventDateTitle: (state) => ({date}) => {
    return state.events[date] 
      ? state.events[date].label
      : '';
  },
  getTimeLineStart: (state) => {
    return state.timeline.start;
  },
  getTimeLineEnd: (state) => {
    return state.timeline.end;
  },
}

const actions = {
  setActiveEvent({commit}, {date}) {
    commit('navigate', {
      date
    })
  },
}
const mutations = {
  navigate(state, {date}) {
    state.active = date;
  },
}

/**
 * Export
 */
export default {
  state,
  getters,
  actions,
  mutations
}
